import { DepartmentOverduePanel } from '../components/tasks/DepartmentOverdue.tsx';
import { useTaskDepartments } from '../api/taskQueries.ts';
import { LoadFailure } from '../components/LoadFailure.tsx';

/**
 * Overdue by department (A-#145): tiers 1-2's view of every department's overdue work, one tab each, from the Agency
 * menu. The departments are the server's department_overdue list; each tab's read is refused (403) to anyone who may
 * not open that department's queue, whatever reaches this page.
 */
export function OverdueByDepartment() {
  const departments = useTaskDepartments();
  const none = departments.data !== undefined && departments.data.department_overdue.length === 0;
  return (
    <div className="min-h-dvh bg-page">
      <div className="mx-auto max-w-[96rem] lg:px-6 lg:py-6">
        <header className="page-head">
          <h1 className="page-title">Overdue by department</h1>
          <p className="mt-1 max-w-[60rem] text-sm text-neutral-700">Every open overdue task in each department, whoever holds it.</p>
        </header>
        <div className="page-body pb-4">
          {departments.error && !departments.data ? (
            <LoadFailure what="The departments" error={departments.error} onRetry={() => void departments.refetch()} retrying={departments.isFetching} />
          ) : !departments.data ? (
            <p className="px-4 py-6 text-neutral-700 lg:px-5">Loading…</p>
          ) : none ? (
            <p role="alert" className="px-4 py-6 font-semibold text-neutral-900 lg:px-5">No department's overdue work is open to your roles.</p>
          ) : (
            <DepartmentOverduePanel which="all" className="mx-4 mt-3 lg:mx-5" />
          )}
        </div>
      </div>
    </div>
  );
}
